<template>




     
    <!-- A propos -->
        <section id="apropos" class="view-container  apropos  ">
            <div class="view-content  view-content--one">
                
                <article class="apropos-image">
                    <div class="card-container">
                        <div class="card">
                            <img src="images/pokemon_opale/pokemon13.png"  class="presentation-card" alt="presentation">
                            <img src="images/pokemon_opale/pokemon14.png" class="presentation-card  presentation-card--2" alt="presentation">
                        </div>
                    </div>
                </article>
                <article class="apropos-texte">
                    

                    
                        <h2 class="titre-pokeball">
                            <img src="images/pokeball.svg" alt="pokéball">Un voyage épique
                        </h2>
                        <p class="texte-apropos  apropos-1">
                            <span class="bold">POKéMON Opale</span> est une <span class="bold">aventure ambitieuse</span> qui réunit cinq régions, <span class="bold">plus de soixante villes</span> et un contenu colossal pensé pour offrir une <span class="bold">expérience riche, moderne</span> et totalement personnalisable. <br><br>
                            Le jeu vous permet non seulement <span class="bold">d’explorer librement</span> un monde vaste et <span class="bold">rempli de secrets</span>, mais aussi de créer <span class="bold">vos propres défis</span> grâce à un système de difficultés entièrement modulable. <br><br>
                            <span class="bold">Les arènes sont uniques&nbsp;:</span> chacune possède ses mécaniques, ses règles, ses puzzles et ses contraintes. <span class="bold">Un système d’échanges complet</span> est proposé, un POKéDEX de <span class="bold">plus de 600 POKéMON</span>, des combats dynamiques (simples ou doubles), des <span class="bold">cartes à collectionner</span> avec plus de 150 cartes, <span class="bold">des mini-jeux</span>, des <span class="bold">quêtes annexes</span> dans chaque ville et un <span class="bold">scénario profond</span> articulé autour de deux héros dont les histoires se croisent et influencent votre progression. <br><br>
                            <span class="bold">L’exploration, la stratégie et la liberté</span> sont au cœur de l’expérience&nbsp;: vous <span class="bold">choisissez votre chemin</span>, votre style de jeu, votre difficulté, et même votre façon de renforcer votre équipe.<br><br>
                            Conçu pour les <span class="bold">joueurs occasionnels</span> comme pour les <span class="bold">fans exigeants</span>, POKéMON Opale mélange <span class="bold">nostalgie, innovation et ambition</span>, pour créer un fangame vivant, <span class="bold">généreux et inoubliable</span>.<br><br><br>
                        </p>


                        
                    


                        <h2 class="titre-pokeball">
                            <img src="images/pokeball.svg" alt="pokéball">Une aventure sur mesure
                        </h2>
                        <p class="texte-apropos apropos-3">
                            POKéMON Opale propose <span class="bold">plusieurs modes de difficulté</span>, permettant à chaque joueur de personnaliser son aventure selon ses préférences. Que vous soyez un novice ou un expert, ces options vous offrent la possibilité de <span class="bold">vivre une expérience sur mesure</span>, adaptée à votre style de jeu.<br>
                            <br>
                            <span class="bold">Cliquez sur un mode pour en savoir plus.</span>
                        </p>
                        <!-- FACILE -->
                        <div class="unedifficulte">          
                            <label for="facile" class="cta  cta-difficulte">🟢 Facile</label>
                            <input type="checkbox" id="facile" class="toggle-difficulte">
                            <article class="texte-facile texte-difficulte">
                                <p class="bold">
                                    Un mode pensé pour profiter de l’aventure sans pression.  
                                    Idéal pour découvrir l’univers de POKéMON Opale en toute tranquillité.
                                </p>

                                <ul class="list-difficulte">
                                    <li>Le niveau des POKéMON est toujours affiché.</li>
                                    <li>5 MULTI EXP pour répartir librement l’expérience.</li>
                                    <li>Le nombre de POKéMON des dresseurs est visible.</li>
                                    <li>Le prochain POKéMON ennemi est annoncé.</li>
                                    <li>Changement de POKéMON autorisé avant l’entrée du suivant.</li>
                                    <li>Objets utilisables en combat contre les dresseurs.</li>
                                    <li>EXP de capture augmentée de 25%.</li>
                                    <li>Sauvegarde possible à tout moment.</li>
                                    <li>Soins gratuits et illimités dans les Centres POKéMON.</li>
                                    <li>Objets de l’inventaire illimités.</li>
                                    <li>Combats simples ou doubles selon le scénario (pas de hasard).</li>
                                    <li>Niveaux d’évolution normaux.</li>
                                    <li>Aucun objet perdu en cas de défaite.</li>
                                    <li>Perte de 50% de l’argent en cas de défaite.</li>
                                    <li>Un POKéMON mis KO ne perd pas son expérience.</li>
                                    <li>Objets de soin toujours efficaces.</li>
                                    <li>POKéMON des dresseurs sans bonus de statistiques.</li>
                                    <li>Dégâts infligés normaux (100%).</li>
                                    <li>10% de chance pour un sauvage de fuir sous 5% PV.</li>
                                    <li>Taux de capture inchangé.</li>
                                </ul>
                            </article>
                        </div>



                        <!-- NORMAL -->
                        <div class="unedifficulte">
                            <label for="normale" class="cta  cta-difficulte">🟡 Normale</label>
                            <input type="checkbox" id="normale" class="toggle-difficulte">
                            <article class="texte-normale texte-difficulte">

                                <p class="bold">
                                    Une expérience équilibrée et fidèle à l’esprit classique.  
                                    Le défi augmente légèrement sans devenir punitif.
                                </p>

                                <ul class="list-difficulte">
                                    <li>Le niveau des POKéMON est affiché.</li>
                                    <li>3 MULTI EXP disponibles.</li>
                                    <li>Le nombre de POKéMON ennemis est visible.</li>
                                    <li>Le prochain POKéMON ennemi n’est pas annoncé.</li>
                                    <li>Changement de POKéMON autorisé avant celui de l’adversaire.</li>
                                    <li>Objets interdits contre les dresseurs.</li>
                                    <li>EXP de capture normale.</li>
                                    <li>Sauvegarde possible partout.</li>
                                    <li>Soins payants mais illimités en Centre POKéMON.</li>
                                    <li>Objets de l’inventaire illimités.</li>
                                    <li>Combats simples/doubles définis par le scénario.</li>
                                    <li>Niveaux d’évolution augmentés de 10%.</li>
                                    <li>Perte d’un seul objet de chaque type en cas de défaite.</li>
                                    <li>Perte totale de l’argent si défaite.</li>
                                    <li>Un POKéMON KO perd son expérience accumulée.</li>
                                    <li>Objets de soin fonctionnent normalement.</li>
                                    <li>+10% en statistiques pour les POKéMON dresseurs.</li>
                                    <li>Dégâts infligés normaux (100%).</li>
                                    <li>15% de chance de fuite sauvage sous 10% PV.</li>
                                    <li>-15% de taux de capture (défini par la variable 613).</li>
                                </ul>

                            </article>
                        </div>



                        <!-- DIFFICILE -->
                        <div class="unedifficulte">
                            <label for="difficile" class="cta  cta-difficulte">🔴 Difficile</label>
                            <input type="checkbox" id="difficile" class="toggle-difficulte">
                            <article class="texte-difficile texte-difficulte">

                                <p class="bold">
                                    Un mode pour joueurs en quête d’un vrai challenge.  
                                    Gestion stricte, ressources limitées et combats plus imprévisibles.
                                </p>

                                <ul class="list-difficulte">
                                    <li>Le niveau des POKéMON est affiché.</li>
                                    <li>1 seul MULTI EXP disponible.</li>
                                    <li>Le nombre de POKéMON des dresseurs est masqué.</li>
                                    <li>Le prochain POKéMON ennemi n’est pas annoncé.</li>
                                    <li>Changement de POKéMON autorisé avant l’adversaire.</li>
                                    <li>Objets interdits en combat contre les dresseurs.</li>
                                    <li>EXP de capture normale.</li>
                                    <li>Sauvegarde uniquement via objet ou Centre POKéMON.</li>
                                    <li>Soins payants et illimités.</li>
                                    <li>Objets limités à 5 exemplaires chacun.</li>
                                    <li>20% de chance que chaque combat de dresseur soit un double.</li>
                                    <li>Niveaux d’évolution +20%.</li>
                                    <li>Perte de tous les objets en cas de défaite.</li>
                                    <li>Perte totale de l’argent en cas de défaite.</li>
                                    <li>Un POKéMON KO perd son expérience.</li>
                                    <li>40% de chance qu’un objet de soin ait un effet négatif.</li>
                                    <li>+20% en statistiques pour les POKéMON dresseurs.</li>
                                    <li>Dégâts du joueur réduits de 10%.</li>
                                    <li>25% de chance de fuite sauvage sous 10% PV.</li>
                                    <li>Taux de capture réduit de 10%.</li>
                                </ul>

                            </article>
                        </div>


                        <div class="unedifficulte">
                            <label for="expert" class="cta  cta-difficulte">
                                ⚫ Expert
                            </label>
                            <input type="checkbox" id="expert" class="toggle-difficulte">
                            <article class="texte-expert  texte-difficulte">
                                <p class="bold">Le summum du défi, réservé aux joueurs les plus aguerris.
                                    <br>Chaque décision compte, et la moindre erreur peut être fatale.</p>
                                <ul class="list-difficulte">
                                    <li>Le niveau des POKéMON est masqué.</li>
                                    <li>1 seul MULTI EXP permet de répartir l’expérience.</li>
                                    <li>Le nombre de POKéMON des dresseurs est inconnu.</li>
                                    <li>Le type du prochain POKéMON de l'ennemi n’est pas annoncé.</li>
                                    <li>Impossible de changer de POKéMON avant que l’adversaire n’envoie le sien.</li>
                                    <li>Les objets sont inutilisables en combat contre les dresseurs.</li>
                                    <li>L’expérience de dresseur gagnée après capture reste normale.</li>
                                    <li>La sauvegarde nécessite un objet spécifique ou d’être dans un Centre POKéMON.</li>
                                    <li>Les soins dans les Centres POKéMON sont payants, selon le nombre de POKéMON à soigner et limités à un par centre, tant que le joueur n'en n’a pas visité un autre.</li>
                                    <li>Chaque objet est limité à un seul exemplaire dans l’inventaire sauf les balls.</li>
                                    <li>50% de chance que chaque combats contre un dresseur soit un combat double.</li>
                                    <li>Les niveaux d’évolution augmentent de 35% par rapport à la norme.</li>
                                    <li>Perte de tous les objets en cas de défaite.</li>
                                    <li>Perte de la totalité de l'argent en cas de défaite.</li>
                                    <li>Un pokemon mis KO perd son expérience accumulée à son niveau actuel.</li>
                                    <li>60% de chance que les objets de soin aient un effet négatif aléatoire (poison, sommeil, etc.).</li>
                                    <li>Les POKéMON des dresseurs bénéficient d’un bonus de +30% en statistiques.</li>
                                    <li>Les dégâts infligés par le joueur sont réduits de 10%.</li>
                                    <li>Les POKéMON sauvages ont 30% de chance de fuir s’ils sont à moins de 10% de leurs PV max.</li>
                                    <li>Le taux de capture des POKéMON sauvages est réduit de 20% (jusqu’à 1/255).</li>
                                </ul>
                            </article>
                        </div>
                        
                    <div class="cta-container  hide">
                        <a href="#telechargement" class="cta">
                            Télecharger
                        </a>
                    </div>
                </article>
                
            </div>
        </section>
    <!-- A propos -->






     
    <!-- A propos -->
        <section class="view-container  apropos  ">
            <div class="view-content  view-content--reverse">
                <article class="apropos-texte">
                    <h2 class="titre-pokeball">
                        <img src="images/pokeball.svg" alt="pokéball">À propos
                    </h2>
                        <p class="texte-apropos">
                            Créé par un fan passionné de la saga POKéMON, <span class="bold">POKéMON Opale</span> est bien plus qu'un simple hommage. Ce jeu propose une expérience unique qui respecte et s'inspire de la richesse des générations précédentes tout en introduisant des <span class="bold">innovations captivantes</span>.<br>
                            Avec des mécaniques repensées et un <span class="bold">souci du détail</span>, chaque aspect du jeu a été minutieusement conçu pour offrir aux joueurs une aventure POKéMON comme jamais auparavant.
                        </p>
                        <p class="texte-apropos">
                            L'un des points forts de POKéMON Opale réside dans sa capacité à <span class="bold">revisiter les bases</span> classiques tout en apportant des <span class="bold">améliorations significatives</span>. Par exemple, certaines fonctionnalités emblématiques, comme les CS, ont été totalement réinventées, permettant <span class="bold">une exploration plus fluide et sans contraintes</span>. Les joueurs pourront également découvrir des quêtes riches en histoire, des objets spéciaux et des interactions complexes avec les dresseurs.
                        </p>
                        <p class="texte-apropos apropos-2">
                            L'immersion est renforcée par <span class="bold">l'attention portée aux détails</span> des villes, des PNJs et des régions, créant ainsi un monde cohérent et vivant. Avec une aventure complète et des heures de contenu inédit, POKéMON Opale promet de séduire à la fois les <span class="bold">fans de longue date et les nouveaux venus</span> dans l'univers POKéMON.
                            <br/><br/><br/>
                        </p>
                        <h2 class="titre-pokeball">
                            <img src="images/pokeball.svg" alt="pokéball">Créez votre arène
                        </h2>
                        <p class="texte-apropos apropos">
                            POKéMON Opale pousse plus loin ce que les jeux officiels n’ont jamais proposé&nbsp;: la liberté totale de <span class="bold">créer votre propre arène personnalisée</span>, avec votre style, <span class="bold">vos règles et votre badge unique</span>. <br><br>
                            Vous choisissez l'ambiance de l’arène, vous <span class="bold">nommez votre badge</span>, puis vous construisez trois équipes distinctes&nbsp;: deux équipes de challengers pour tester les joueurs, et <span class="bold">l’équipe finale du champion</span> que vous incarnez. <br><br>
                            Chaque POKéMON ne peut apparaître que dans une seule équipe, forçant des <span class="bold">choix stratégiques</span> et une réflexion digne d’un <span class="bold">véritable maître.</span><br><br>
                            <span class="bold">Victoire inscrite à vie</span>, défaite réessayable, zéro argent, zéro expérience&nbsp;: <span class="bold">seul le talent compte</span>.<br><br>
                        </p>



                        

                </article>
                


                
                <article class="apropos-image">
                    <div class="card-container">
                        <div class="card">
                            <img src="images/pokemon_opale/pokemon10.png"  class="presentation-card" alt="presentation">
                            <img src="images/pokemon_opale/pokemon12.png" class="presentation-card  presentation-card--2" alt="presentation">
                        </div>
                    </div>
                </article>
            </div>
        </section>



        <section class="view-container  apropos  ">
             <div class="view-content  view-content--qui">
                <article class="apropos-texte apropos-texte-qui">


                        <h2 class="titre-pokeball">
                            <img src="images/pokeball.svg" alt="pokéball">Des passionés derrière le projet
                        </h2>

                    
                        <p  class="texte-apropos">
                            <span class="bold">POKéMON Opale</span>. est avant tout le fruit de la passion.<br/>
                            Derrière ce projet, on retrouve <span class="bold">ANGI-MK</span>, fan inconditionnel de la série depuis les toutes premières versions sur GAME BOY.<br/>
                            Après avoir créé <span class="bold">POKéMON Gemme</span> au début des années 2010, il a ressenti le besoin de revenir à ses premières amours&nbsp;: l’univers riche, mystérieux et plein d’émotion de la <span class="bold">deuxième génération</span>. <br/>
                            Son objectif ? Créer une aventure inédite tout en respectant l’âme des jeux originaux, sans jamais dénaturer l’esprit des opus officiels.
                        </p>

                        <div class="sections-auteurs">
                            <div class="auteur-un">
                                    <a href="https://www.facebook.com/tontonangi" target="_blank" class="link-over"></a>
                                    <div class="nom_photo">
                                         <div class="card-container">
                                            <div class="card">
                                                <img src="images/angi-mk.png" class="karel presentation-card" alt="Angi-MK"><br/>
                                            </div>
                                        </div>
                                        <h4>Le chef d'orchestre</h4><br/>
                                        <h2>ANGI-MK</h2><br/>
                                        <div class="cta-container">
                                            <a href="https://www.facebook.com/tontonangi" target="_blank" class="cta" >LE CONTACTER</a>
                                        </div><br/><br/>
                                    </div>
                                <p class="texte-apropos">
                                    <span class="bold">Passionné de jeux vidéo</span> depuis l’enfance et grand <span class="bold">collectionneur de cartes</span>, de <span class="bold">consoles</span> et de <span class="bold">jeux rétro</span>, nourri par des années d’univers POKéMON. 
                                    Après avoir développé <span class="bold">POKÉMON Gemme</span> et attiré par la scène des <span class="bold">fangames</span>, il développe aujourd’hui <span class="bold">POKéMON Opale</span> avec une approche mêlant technique, créativité et <span class="bold">respect de la licence</span>. 
                                    Il conçoit les <span class="bold">mécaniques</span>, le <span class="bold">scénario</span> et l'<span class="bold">identité du jeu</span>, en apportant une vision aboutie, moderne et <span class="bold">fidèle à l’esprit de la série</span> tout en y ajoutant sa propre sensibilité.
                                </p>
                            </div>

                            
                            <div class="auteur-un">
                                <a href="https://allmylinks.com/karelbsl" target="_blank" class="link-over"></a>
                                    <div class="nom_photo">
                                         <div class="card-container">
                                            <div class="card">
                                                <img src="images/karel.png" class="karel presentation-card" alt="Karel"><br/>
                                            </div>
                                        </div>
                                        <h4>Le dessinateur</h4><br/>
                                        <h2>LarelBSL</h2><br/>
                                        <div class="cta-container">
                                            <a href="https://allmylinks.com/karelbsl" target="_blank" class="cta" >VOIR SES CRÉATIONS</a>
                                        </div><br/><br/>
                                    </div>
                                <p class="texte-apropos">
                                    Pour donner vie à cet univers, <span class="bold">ANGI-MK</span> est épaulé par un <span class="bold">dessinateur talentueux</span>, auteur de mangas basé à Toulouse.
                                    Grand amateur de <span class="bold">POKéMON</span> et <span class="bold">Dragon Ball</span>, qui travaille actuellement sur <span class="bold">sa propre série</span> intitulée <span class="bold">Rage</span>, tout en collaborant à d'autres projets comme <span class="bold">POKéMON Opale</span>.
                                    C’est lui qui réalise les <span class="bold">artworks exclusifs</span> des POKéMON du jeu, avec un <span class="bold">style expressif et cohérent</span>, fidèle à l’ambiance de la série tout en y ajoutant <span class="bold">sa touche artistique</span>.
                                </p>
                            </div>

                        </div>

                        
                    <div class="cta-container  hide">
                        <a href="#telechargement" class="cta">
                            Télecharger
                        </a>
                    </div>
                </article>
            </div>

            
        </section>
    <!-- A propos -->
</template>

<script>
    export default {
        name: 'Apropos',
        data() {
            return {
            };
        },
        methods: {
        },
        mounted() {
        },
    };
</script>

<style scoped>
    .texte-apropos{
        margin-bottom: 20px;
    }
    .toggle-difficulte{
        display: none;
    }
    .apropos-texte{
        padding: 20px;
        background-color: white;
        border-radius:20px;
        width: 60%;
    }
    .apropos-texte-qui{
        width:100%;
    }
    .apropos-image{
        width: 40%;
        min-width: 320px;
    }
    .sections-auteurs{
        display:flex;
        gap: 40px;
        flex-wrap: wrap;
    }
    .auteur-un{
        width: calc(50% - 60px);
        min-width: 200px;
        padding: 20px;
        background: #dfbeb087;
        border-radius: 20px;
        position:relative;
    }
    .nom_photo{
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }

    .cta-difficulte{
        width:120px;
    }

    .texte-difficulte{
        border-radius: 20px;
        margin: 0;
        transition: 0.3s;
        transform: scaleY(0);
        max-height: 0px;
        padding:0px;
    }
    .toggle-difficulte:checked + .texte-difficulte{
        
        transform: scaleY(1);
        padding:20px;
        margin: 20px 0 30px;
        max-height: 5000px;
    }
    .unedifficulte{
        margin: 20px 0;
    }
    .texte-facile{
        background: #daffe7;
    }
    .texte-normale{
        background: #fcffda;
    }
    .texte-difficile{
        background: #ffdede;
    }
    .texte-expert{
        background: #e4e4e4;
    }
    .list-difficulte li{
        list-style: disc;
        margin-left: 20px;
        line-height: 25px;
    }
    .presentation-card{
        width: calc(100% - 40px);
        padding: 20px;
    }
    .card{
        position: relative;   
        overflow: visible !important;
    }
    .presentation-card--2{
        position: absolute;
        top: 0;
        left: 0;
        animation: showhide 4s linear infinite;
    }
    .karel{
        width: 100%;
        max-width: 250px;
    }

    @keyframes showhide {
        0% {
            opacity: 0;
        }
        50% {
            opacity: 1;
        }
        100% {
            opacity: 0;
        }
    }

    .link-over{
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 10;
    }

    .apropos-1, .apropos-2{
        border-bottom: solid 1px #b2b2b2;
        margin-bottom: 40px;
    }


    .card-container {
        perspective: 1000px;
        width: 80%;
        margin: 0 auto;
    }
    .card {
        width: 100%;
        height: 100%;
        position: relative;
        transform-style: preserve-3d;
        transition: transform 0.6s;
        transform: rotateY(0deg);
        filter: drop-shadow(12px 12px 6px #00000055);
        transition: 0.3s;
        overflow: hidden;
    }
    .link-over:hover ~ .nom_photo .card {
        transform: rotateY(15deg);
        filter: drop-shadow(-12px 12px 6px #00000055);
    }

    .link-over:hover ~ .nom_photo .cta{
    transform: translateY(4px);
}

    .card-front {
        z-index: 2;
        transform: rotateY(0deg);
    }
    .card-back {
        transform: rotateY(180deg);
    }



    .view-content--one{
        display: flex;
        justify-content: center;
        align-items: center;
        width: calc(100% - 82px);
        max-width: 1600px;
        margin: auto;
        background: #38539f33;
        backdrop-filter: blur(15px);
        -webkit-backdrop-filter: blur(15px);
        border-radius: 50px;
        padding: 40px 40px;    
        border: solid 1px #4a516a;
    }

    .view-content--reverse{
        display: flex;
        justify-content: center;
        align-items: center;
        width: calc(100% - 82px);
        max-width: 1600px;
        margin: auto;
        background: #fe733b33;
        backdrop-filter: blur(15px);
        -webkit-backdrop-filter: blur(15px);
        border-radius: 50px;
        padding: 40px 40px;
        border: solid 1px #9e2121;
    }

    
    .view-content--qui{
        display: flex;
        justify-content: center;
        align-items: center;
        width: calc(100% - 82px);
        max-width: 1600px;
        margin: auto;
        background: #fe733b33;
        backdrop-filter: blur(15px);
        -webkit-backdrop-filter: blur(15px);
        border-radius: 50px;
        padding: 40px 40px;
        border: solid 1px #9e2121;
    }
    .card{
            text-align: center;
    }

    @media screen and (max-width: 1200px){
        .view-container.infos{
            height: auto !important;
        }
        .sections-auteurs{
            flex-direction: column;
        }
        .auteur-un{
            width: calc(100% - 40px);
            padding: 20px;

            min-width: 200px;
            padding: 20px;
            background: #dfbeb087;
            border-radius: 20px;
            position: relative;
        }
        
        .view-content{
            width:100%;
        }
        .apropos-texte, .view-content, .view-container{
            border:none;
            border-radius: 0;
        }

        .card-container{
            display: block !important;
            width: 100% !important;
        }
        .view-content--reverse{
            flex-direction: column-reverse !important;

        }
        .view-content--one{
            flex-direction: column !important;

        }
    }

    @media screen and (max-width: 900px){
        .card-container{
            display: none;
        }
        .apropos-texte{
            width: calc(100% - 40px);
            padding:20px
        }
        .view-content{
            flex-direction: column;
        }
        #apropos{
            padding-top: 40px;
        }
        
    }
</style>